import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNotify, fetchStart, fetchEnd, } from 'react-admin';
import Button from '@material-ui/core/Button';
import { sgxDownload } from '../../libs/sgx/api/fetch';

const DownloadButton = ({
        url,
        filename,
    }) => {
        const [loading, setLoading] = useState(false);
        const notify = useNotify();
        const dispatch = useDispatch();

        const handleClick = () => {
            setLoading(true);
            dispatch(fetchStart()); // start the global loading indicator 

            sgxDownload(url, filename)
                .catch(() => {
                    notify('reportes.cant_download', 'warning')
                })
                .finally(() => {
                    setLoading(false);
                    dispatch(fetchEnd()); // stop the global loading indicator
                });
        };

        return (
            <Button onClick={handleClick} color="primary" size="small" disabled={!url || loading}>
                Descargar
            </Button>
        );
    };

export default DownloadButton;